import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule } from '@angular/forms';
import { DiscussionRoutes } from './discussion.routing';

import {MatPaginatorModule} from '@angular/material/paginator';
import { NgxPermissionsModule } from 'ngx-permissions';
import { AddstreammpgComponent } from './addstreammpg/addstreammpg.component';
import { ViewstreammpgComponent } from './viewstreammpg/viewstreammpg.component';
import { PosttopicComponent } from './posttopic/posttopic.component';
import { SavetopicComponent } from './savetopic/savetopic.component';
import { FileUploadModule } from 'ng2-file-upload';
import { FreedownloadComponent } from './freedownload/freedownload.component';
import { AddfreedownloadComponent } from './addfreedownload/addfreedownload.component';

import { TagInputModule } from 'ngx-chips';
import { CKEditorModule } from 'ng2-ckeditor';
import { AdminForumComponent } from './admin-forum/admin-forum.component';
import { dsanitizeHtmlPipe } from './sanitize-html.pipe';
import { AdminblogComponent } from './adminblog/adminblog.component';
import { VgroupComponent } from './vgroup/vgroup.component';
import { GroupdetailsComponent } from './groupdetails/groupdetails.component';
import { VguserComponent } from './vguser/vguser.component';



@NgModule({
  imports: [ 
    CommonModule,
    RouterModule.forChild(DiscussionRoutes),
    NgbModule,
    FormsModule,
    MatPaginatorModule,
    NgxPermissionsModule.forChild(),
    FileUploadModule,
    CKEditorModule,
    TagInputModule,
  ],
  declarations: [
    AddstreammpgComponent,
    ViewstreammpgComponent,
    PosttopicComponent,
    SavetopicComponent,
    FreedownloadComponent,
    AddfreedownloadComponent,
    AdminForumComponent,
    dsanitizeHtmlPipe,
    AdminblogComponent,
    VgroupComponent,
    GroupdetailsComponent,
    VguserComponent
  ],
  exports:[dsanitizeHtmlPipe,AdminForumComponent]
  
})

export class DiscussionModule {


}



// WEBPACK FOOTER //
// C:/projects/wct-nextias-ui/src/app/discussion/discussion.module.ts